module.exports = __webpack_public_path__ + "img/Case_14.15d2eda8.jpg";